import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hasRequiredFields',
    standalone: false
})
export class HasRequiredFieldsPipe implements PipeTransform {
    transform(table: any): boolean {
        if (!table || !table.fields || !Array.isArray(table.fields)) {
            return false;
        }

        return table.fields.some((field: any) => field.required === true);
    }
}
